// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// GA Setthings
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const app = initializeApp(process.env.FIREBASE_CONFIG)
const analytics = getAnalytics(app)

// firebase alias
Vue.prototype.$firebase = app
Vue.prototype.$analytics = analytics

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js